import { User } from 'firebase/auth';

import ContentApi from '../api/contentApi';
import StatApi from '../api/statApi';
import { ContentData, ContentType } from '../types/contentTypes';
import SectionData from '../types/SectionData';
import { StatType } from '../types/statData';
import { getEnumKeyByEnumValue, swapLocations } from '../utils/functions';
import { startCase } from 'lodash';

export default class ContentService {
  private static readonly completableContents = ['TEXT', 'QUIZ'];

  public static async getUniqueContentTypesBySectionID(sectionID: string) {
    const data = await ContentApi.getContentsBySectionId(sectionID);
    return [...new Set(data.map(d => d.type))];
  }

  public static canContentBeCompleted(content: ContentData) {
    if (this.completableContents.includes(content.type)) {
      return true;
    } else return false;
  }

  public static async getIncompleteContentsForUser(section: SectionData, user: User): Promise<ContentData[]> {
    const contents = await ContentApi.getContentsBySectionId(section.id);
    const allContentStatsForUser = await StatApi.getStatsWithTypeAndUserId(StatType.Content, user.uid);
    const allCompletedContentsIds = allContentStatsForUser.map(stat => stat.targetId);
    return contents.filter(content => !allCompletedContentsIds.includes(content.id));
  }

  public static async getFirstIncompleteContent(section: SectionData, user: User): Promise<ContentData | undefined> {
    const incompleteSkillPages = await this.getIncompleteContentsForUser(section, user);
    return incompleteSkillPages[0];
  }

  public static swapContentsInArray(index1: number, index2: number, contents: ContentData[]) {
    const contentsCopy = [...contents];
    swapLocations(contentsCopy, index1, index2);
    const updatedContents = contentsCopy.map((content, i) => ({ ...content, order: i + 1 } as ContentData));
    ContentApi.updateContents(updatedContents);
    return updatedContents;
  }

  public static getContentRowText(content: ContentData) {
    if (content.headline) {
      return content.headline;
    } else if ('description' in content && content.description) {
      return content.description;
    } else if ('text' in content && content.text) {
      return content.text;
    } else {
      const enumKey = getEnumKeyByEnumValue(ContentType, content.type);
      return enumKey ? startCase(enumKey) : 'Unknown content';
    }
  }
}
